module.exports = __webpack_public_path__ + "public/1.0.1_896977/img/horizontallogo.23bd770e.svg";